import React from 'react';
import Accent from '@/components/typography/Accent';
import Paragraph from '@/components/typography/Paragraph';

const HtmlCss = () => (
  <>
    <Paragraph>
      I am comfortable writing hand-coded HTML and thorough my career I have
      developed an ability to build <Accent>complex responsive layouts</Accent>{' '}
      using <Accent>modular HTML5 and CSS</Accent> (with BEM method back in the
      day) .
    </Paragraph>
    <Paragraph>
      Adopting a mobile-first approach, I ensure I provide logical, consistent
      and scalable code. I am aware of{' '}
      <Accent>cross-browser differences</Accent>, and I am proficient with
      browser testing and problem solving.
    </Paragraph>
    <Paragraph>
      As things have evolved I am now using{' '}
      <Accent>JSX within the React framework</Accent> in association with{' '}
      <Accent>styled-components</Accent> to build reusable components and
      features.
    </Paragraph>
    <Paragraph>
      Attached to the meaning of words, I am into{' '}
      <Accent>semantic coding practices </Accent>
      and I strive to develop well-structured, maintainable, W3C valid code.
    </Paragraph>
  </>
);

HtmlCss.propTypes = {};

export default HtmlCss;
